import { nanoid } from 'nanoid/async'

import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import { userInputFlowModal } from './userInputFlowModal'
import {
  updateNodeConnections,
  createUserInputFlowSingleNode,
  removeConnectionsHavingUnmatch,
} from '../../functions/utils'

// eslint-disable-next-line no-unused-vars
export default async (node, editor) => {
  const oldData = node.data
  const { value: userInputFlowData } = await userInputFlowModal(oldData, node)

  if (userInputFlowData && Object.values(userInputFlowData).length > 0) {
    // Create user input flow unique ID if there is not any
    if (! ('uniqueId' in node.data)) {
      node.data.uniqueId = await nanoid(15)
    }

    Object.assign(node.data, userInputFlowData)

    const outputClass = CONST_SOCKET.USER_INPUT_FLOW_OUTPUT.toLowerCase()

    if ('new' === node.data.userInputFlowIdValue) {
      // Show output socket if it was hidden
      $(node.vueContext.$el.childNodes[1])
        .find('.' + outputClass)
        .parent()
        .removeClass('d-none')

      if (node.outputs instanceof Map) {
        const mapToArray = Array.from(node.outputs)
        
        if (mapToArray[0][1]) {
          const nodeObject = mapToArray[0][1]

          if (0 === nodeObject.connections.length) {
            attachUserInputFlowSingleToUserInputFlowNode(node)    
          }
        }
      }
    } else {
      if (node.outputs instanceof Map) {
        const mapToArray = Array.from(node.outputs)

        if (mapToArray[0][1]) {
          const nodeObject = mapToArray[0][1]
          
          if (nodeObject.connections.length > 0) {
            const connections = nodeObject.connections.slice()
            connections.forEach(connection => {
              editor.removeConnection(connection)
            })  
          }
        }

        // Hide output socket
        $(node.vueContext.$el.childNodes[1])
          .find('.' + outputClass)
          .parent()
          .addClass('d-none')
      }
    }



    node.update()
    updateNodeConnections(node)

    const match = ['userInputFlowSingle']
    removeConnectionsHavingUnmatch(node, match, CONST_SOCKET.QUICK_REPLY_OUTPUT)    
  }

  return false
}

const attachUserInputFlowSingleToUserInputFlowNode = async (node) => {
  const userInputFlowSingleNode = await createUserInputFlowSingleNode()
  userInputFlowSingleNode.position = [node.position[0] + 250, node.position[1]]

  App.editor.addNode(userInputFlowSingleNode)

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.USER_INPUT_FLOW_OUTPUT),
    userInputFlowSingleNode.inputs.get(CONST_SOCKET.USER_INPUT_FLOW_SINGLE_INPUT)
  )
}